// material-ui
import { Typography } from '@mui/material';
import { MenuListProps } from './interface';

// project imports
import NavGroup from './NavGroup';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = (props: MenuListProps) => {
  const navItems = props.menuItems.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} onItemClick={props.onItemClick}/>;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error 1
          </Typography>
        );
    }
  });

  return <>{navItems}</>;
};

export default MenuList;
